import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Fuse from 'fuse.js';

//import ClusterMarker from './ClusterMarker';
import {
  getSegments,
  getSearchItems,
  getOptions,
  changeMode,
  removeUrlParameter,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';
import constants, { ViewMode } from '../../constants';
import FindMyPartOptionsPsg from './FindMyPartOptionsPsg';
import FindMyPartOptionsGeneral from './FindMyPartOptionsGeneral';
import {} from './findMyPartFunctions';

const FindMyPartContainer = ({
  preSetBrand = null,
  preSetModel = null,
  preSetYear = null,
  preSetSegment = null,
  title = '',
  description = '',
  isInBlock = false,
  useH1Title = false,
  ignoreSetCookie = false,
}) => {
  const findMyPartRef = useRef();
  const products = useSelector((state) => state.findMyPart.products);
  const segments = useSelector((state) => state.findMyPart.segments);
  const searchItems = useSelector((state) => state.findMyPart.searchItems);
  const dispatch = useDispatch();
  const [activeSegment, setActiveSegment] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [psgSearchItems, setPsgSearchItems] = useState(false);

  const [initBrandValue, setBrandValue] = useState({});
  const [initModelValue, setModelValue] = useState({});
  const [initYearValue, setYearValue] = useState({});
  const [customerSegmentChanged, setCustomerSegmentChanged] = useState(false);
  const toggleSegment = (segment) => {
    let newFilterList = [];
    setActiveSegment(segment);
    dispatch(removeUrlParameter('brand'));
    dispatch(removeUrlParameter('model'));
    dispatch(removeUrlParameter('year'));
  };
  useEffect(() => {
    async function setup() {
      dispatch(getSearchItems());
      if (!mounted) {
        setMounted(true);
      }
    }
    setup();
  }, []);

  const wipeSearchResults = () => {
    const searchResultContainer = document.querySelector(
      '.find-my-part__search-result'
    );
    if (searchResultContainer) {
      searchResultContainer.innerHTML = '';
    }
  };

  useEffect(() => {
    dispatch(getSegments());
  }, [dispatch]);
  useEffect(() => {
    if (mounted) {
      setFilters();
    }
  }, [products]);

  useEffect(() => {
    if (searchItems?.length > 0) {
      setPsgSearchItems(
        new Fuse(searchItems, {
          keys: ['brand', 'model', 'year'],
          threshold: 0.3,
          distance: 10,
        })
      );
    }
  }, [searchItems]);

  useEffect(() => {
    if (segments && segments.length > 0) {
      let initSegment = segments[0];
      if (preSetSegment) {
        const foundSegment = segments.find(
          (x) => x.id == preSetSegment.toLowerCase()
        );
        if (foundSegment) {
          initSegment = foundSegment;
        }
      }
      setActiveSegment(initSegment);
      /*console.log('segments', segments);*/
    }
  }, [segments]);

  useEffect(() => {
    if (activeSegment) {
      // Empty search result container
      if (customerSegmentChanged) {
        wipeSearchResults();
      }
      setCustomerSegmentChanged(true);
      if (isInBlock || (preSetBrand && preSetModel)) {
        // Intentional only having value
        const urlBrand = preSetBrand
          ? { value: preSetBrand, text: preSetBrand, selected: true }
          : {};
        setBrandValue(urlBrand);

        const urlModel = preSetModel
          ? { value: preSetModel, text: preSetModel, selected: true }
          : {};
        setModelValue(urlModel);

        const urlYear = preSetYear
          ? { value: preSetYear, text: preSetYear, selected: true }
          : {};
        setYearValue(urlYear);

        const options = {
          lastChangedOptionType: isInBlock && preSetModel ? 'model' : 'brand',
          segment: activeSegment,
          ignoreSetCookie,
          optionsGeneral: !activeSegment.isPsg
            ? {
                brand: urlBrand,
                model: urlModel,
                year: urlYear,
              }
            : null,
          optionsPsg:
            !isInBlock && activeSegment.isPsg
              ? {
                  brand: urlBrand,
                  model: urlModel,
                }
              : null,
        };

        dispatch(getOptions(options, false, true));
      } else {
        const options = {
          segment: activeSegment,
          optionsGeneral: !activeSegment.isPsg ? {} : null,
          optionsPsg: activeSegment.isPsg ? {} : null,
        };
        dispatch(getOptions(options));
      }
    }
  }, [activeSegment]);

  return (
    <Fragment>
      <div className="row find-my-part__form-wrapper">
        <div className="small-12 medium-12 columns">
          {title && (
            <Fragment>
              {useH1Title ? (
                <h1 className="landingPage-block__title">{title}</h1>
              ) : (
                <h2 className="landingPage-block__title">{title}</h2>
              )}
            </Fragment>
          )}
          {description && (
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          )}
          {segments && segments.length > 0 && (
            <ul className="find-my-part__filter-button-container">
              {segments.map((segment, segmentBtnIndex) => (
                <Fragment key={`dalerListWrapper${segmentBtnIndex}`}>
                  {((!segment.isPsg && isInBlock) || !isInBlock) && (
                    <li
                      className={`find-my-part__filter-button${
                        activeSegment && activeSegment.id === segment.id
                          ? '--active'
                          : ''
                      }`}
                      key={`dalerList${segmentBtnIndex}`}
                    >
                      <button onClick={() => toggleSegment(segment)}>
                        <span>{segment.name}</span>
                      </button>
                    </li>
                  )}
                </Fragment>
              ))}
            </ul>
          )}
          {!isInBlock && activeSegment && activeSegment.isPsg ? (
            <FindMyPartOptionsPsg
              {...{
                activeSegment,
                psgSearchItems,
                initBrandValue,
                initModelValue,
                ignoreSetCookie,
              }}
            />
          ) : (
            <FindMyPartOptionsGeneral
              {...{
                activeSegment,
                isInBlock,
                initBrandValue,
                initModelValue,
                initYearValue,
                preSetSegment,
                wipeSearchResults,
                ignoreSetCookie,
              }}
            />
          )}
        </div>
      </div>
      <div
        className="find-my-part__optimized-result"
        id="find-my-part-optimized-data"
      />
    </Fragment>
  );
};
export default React.memo(FindMyPartContainer);
